import axios from "axios";

export function isContentTypeSimilar(contentType, contentType2) {
    if (contentType != contentType2) {
        return false;
    }
    return true;

}

export async function getSettingData() {
    try{
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/scribe-bot-settings`)
      return res.data.data
    }
    catch(err){
        console.error(err);
        throw err
    }
}